<p-toast></p-toast>
<app-page-shell>
    <app-page-hero eyebrow="Government Integrations" title="Government Onboarding"
        subtitle="Connect your company to Saudi and GCC government digital services for compliance, customs, and transport operations."
        icon="pi pi-shield">
        <div actions>
            <p-button label="Refresh Status" icon="pi pi-refresh" (click)="loadStatuses()"
                      [loading]="loading" severity="secondary"></p-button>
        </div>
    </app-page-hero>

    <app-page-data-panel title="Regional Service Catalog"
        subtitle="Saudi live integrations plus GCC logistics and compliance services planned for LogiLink.">
        <p-tabs [value]="activeCountry" (valueChange)="setActiveCountry($event)" styleClass="government-country-tabs">
            <p-tablist>
                @for (country of countryTabs; track country.key) {
                    <p-tab [value]="country.key">
                        <span class="country-tab-label">
                            <span class="country-name">{{ country.label }}</span>
                            <span class="country-count">{{ country.services.length }}</span>
                        </span>
                    </p-tab>
                }
            </p-tablist>
            <p-tabpanels>
                @for (country of countryTabs; track country.key) {
                    <p-tabpanel [value]="country.key">
                        <div class="country-panel-header">
                            <div>
                                <h3>{{ country.label }}</h3>
                                <p>{{ country.subtitle }}</p>
                            </div>
                            @if (country.key === 'saudi-arabia' && loading) {
                                <p-tag value="Refreshing Live Status" severity="info"></p-tag>
                            }
                        </div>

                        <div class="gateway-grid">
                            @for (service of country.services; track service.id) {
                                <div class="gov-card"
                                     [class.onboarded]="isServiceOnboarded(service)"
                                     [class.coming-soon]="service.comingSoon">
                                    <div class="gov-card-header">
                                        <div class="gov-logo" [class.gov-logo-placeholder]="service.logo.type === 'placeholder'">
                                            @if (service.logo.type === 'image') {
                                                <img [src]="service.logo.src"
                                                     [alt]="service.logo.alt" class="gov-logo-img" />
                                            } @else {
                                                <span class="gov-logo-mark"><i [class]="service.logo.icon"></i></span>
                                                <span class="gov-logo-text">{{ service.logo.text }}</span>
                                            }
                                        </div>
                                        <div class="gov-title-group">
                                            <h2 class="gov-title">{{ service.title }}</h2>
                                            <span class="gov-subtitle">{{ service.subtitle }}</span>
                                        </div>
                                        <p-tag [value]="getServiceTagValue(service)"
                                               [severity]="getServiceTagSeverity(service)"></p-tag>
                                    </div>
                                    <div class="gov-card-body">
                                        <p class="gov-description">{{ service.description }}</p>
                                        <div class="gov-card-meta">
                                            @for (meta of getServiceMeta(service); track meta.text) {
                                                <span class="meta-item">
                                                    <i [class]="meta.icon"></i> {{ meta.text }}
                                                </span>
                                            }
                                        </div>
                                        @if (service.statusSource && loading && isServicePending(service)) {
                                            <div class="gov-meta-skeleton">
                                                <p-skeleton width="9rem" height="1rem"></p-skeleton>
                                            </div>
                                        }
                                    </div>
                                    <div class="gov-card-actions">
                                        <p-button [label]="service.id === 'bayan' && isServiceOnboarded(service) ? 'Remove Credentials' : service.action.label"
                                                  [icon]="service.id === 'bayan' && isServiceOnboarded(service) ? 'pi pi-trash' : service.action.icon"
                                                  [severity]="service.id === 'bayan' && isServiceOnboarded(service) ? 'danger' : (service.action.severity || undefined)"
                                                  [disabled]="isActionDisabled(service)"
                                                  [loading]="isActionLoading(service)"
                                                  [outlined]="service.comingSoon"
                                                  (click)="handleServiceAction(service)"></p-button>
                                    </div>
                                </div>
                            }
                        </div>
                    </p-tabpanel>
                }
            </p-tabpanels>
        </p-tabs>
    </app-page-data-panel>
</app-page-shell>

<p-dialog header="Connect Bayan Naql" [(visible)]="showBayanDialog" [modal]="true" [style]="{ width: 'min(92vw, 480px)' }">
    <div class="bayan-form">
        <div class="field">
            <label for="bayanClientId">Client ID <span class="required">*</span></label>
            <input id="bayanClientId" pInputText [(ngModel)]="bayanClientId"
                   placeholder="Enter your Bayan client ID" class="w-full" />
            <small class="field-hint">The client ID provided by Bayan (Elm) for your company.</small>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Cancel" severity="secondary" [text]="true" (click)="showBayanDialog = false"></p-button>
        <p-button label="Connect" icon="pi pi-link" [loading]="bayanLoading"
                  [disabled]="!bayanClientId.trim()" (click)="submitBayanOnboarding()"></p-button>
    </ng-template>
</p-dialog>
